import { render, staticRenderFns } from "./parcel_revise_douyin.vue?vue&type=template&id=c251271a&scoped=true&"
import script from "./parcel_revise_douyin.vue?vue&type=script&lang=js&"
export * from "./parcel_revise_douyin.vue?vue&type=script&lang=js&"
import style0 from "./parcel_revise_douyin.vue?vue&type=style&index=0&id=c251271a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c251271a",
  null
  
)

export default component.exports